import { createContext, useContext } from "react";
import { TypeSessao as Sessao } from "@/Models/Sessao";
import { NotNullOrUndefinedRecursive } from "@/utility-types";
import { TypeUsuario } from "@/Models/Usuario";

export type TypeSessaoContext = {
  sessao: Sessao | null;
  setSessao: React.Dispatch<React.SetStateAction<Sessao | null>>;
}

export const SessaoContext = createContext<TypeSessaoContext | null>(null);

/**
 * @description Retorna a sessão atual do usuário
 * @returns {Sessao}
 * @throws {Error} Se a sessão não for encontrada
 */
export const useSessao = (): TypeSessaoContext => {
    const context = useContext(SessaoContext);

    if (!context) {
        throw new Error("Sessão não encontrada");
    }

    return context;
};

export const useSessaoObrigatorio = (): NotNullOrUndefinedRecursive<TypeSessaoContext> => {
    const context = useContext(SessaoContext);

    if (!context) {
        throw new Error("Sessão não encontrada");
    }

    const { sessao, setSessao } = context;

    if (sessao == null) {
        throw new Error("'sessao' não encontrado");
    }

    if (setSessao == null) {
        throw new Error("setSessão não encontrado");
    }

    return { sessao, setSessao };
};

export const useUsuario = (): TypeUsuario | null => {
    const { sessao } = useSessao();

    if (sessao == null || sessao.usuario == null) {
        return null;
    }

    return sessao.usuario;
};

export const useUsuarioObrigatoro = (): TypeUsuario => {
    const { sessao } = useSessaoObrigatorio();

    if (sessao.usuario == null) {
        throw new Error("Usuário não encontrado");
    }

    return sessao.usuario;
};

export default SessaoContext;